/**
 * @generated SignedSource<<a572e76e80f62c1e8ce28bbe988323b7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAddToCartButton_viewer$data = {
  readonly addToCartNotificationEnabled: boolean | null;
  readonly " $fragmentType": "PdpSharedAddToCartButton_viewer";
};
export type PdpSharedAddToCartButton_viewer$key = {
  readonly " $data"?: PdpSharedAddToCartButton_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAddToCartButton_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAddToCartButton_viewer",
  "selections": [
    {
      "alias": "addToCartNotificationEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "AddToCartNotification"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"AddToCartNotification\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1bd0356c235b962cf80a59f8a8b4a741";

export default node;
